import React from "react";
import { Link } from "react-router-dom";
import "./PartnerIntro.css";

const PartnerIntro = () => {
  return (
    <div className="partner-container container">
      {/* Left Section */}
      <div className="partner-text">
        <h2 className="intro-heading">Introduction</h2>
        <h3 className="intro-subheading">
          Why Car Wash Is a Future-Ready Franchise Business
        </h3>

        <p className="intro-paragraph">
          Looking to build a business with consistent demand, strong margins, and future-proof technology? At Drive-In Car Spa, we’re opening select channel partner opportunities for entrepreneurs who want to bring a fully-equipped, automation-driven car wash experience to their city or neighborhood. This is more than a vehicle wash setup—it’s a comprehensive ecosystem built for efficiency, branding, and repeat business. With the support of our proven systems and growing reputation, you'll be backed by a brand that delivers quality, speed, and customer trust.
        </p>

        <p className="intro-paragraph">
          The vehicle care industry is seeing rapid, tech-driven growth across urban India. Car owners today are looking for time-efficient, professional services that go beyond traditional hand washing. As water shortages rise and lifestyle convenience becomes a priority, demand for organized car care will only increase. This makes Drive-In Car Spa a high-potential franchise business for entrepreneurs, real estate owners, or auto-sector investors seeking to diversify into a{" "}
          <Link to="/" className="link-text">
            Car detailing dealership in Bangalore
          </Link>.
        </p>
      </div>

      {/* Right Section */}
      <div className="partner-box">
        <div className="partner-box-header">
          What Makes Drive-In Car Spa Different?
        </div>
        <div className="highlight-button">Key Highlights</div>
        <div className="partner-box-body">
          <ul className="highlight-list-1">
            {[
              "High-volume servicing (with our automatic wash bay systems)",
              "Low manual dependency (contactless or semi-automated process)",
              "Flexible location models (standalone or tied to existing service centers)",
              "Add-on services that boost ticket size (coatings, detailing, etc.)",
              "Full operational training and SOPs",
              "Branding and marketing support",
              "Ongoing support in pricing, staffing, and local visibility",
            ].map((item, index) => (
              <li key={index} className={index % 2 === 0 ? "even" : "odd"}>
                <span className="checkmark">✔</span> {item}
              </li>
            ))}
          </ul>

          <div className="partner-btn-wrapper">
            <button className="partner-btn">Partner Us</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerIntro;